<div class="chart-setup-wizard">
  <form class="chart-setup-wizard__form" [formGroup]="setupForm">
    <div class="chart-setup-wizard__intro">
      <h2>Chart Setup</h2>
      <p>
        Use this tile to summarize a datasource visually. Pick the datasource, choose how items
        should be grouped, choose the value to measure, and then select how the chart should be
        drawn.
      </p>
    </div>

    <div class="chart-field">
      <mat-form-field appearance="outline">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" />
        <mat-hint>Sets the heading shown above the chart tile.</mat-hint>
      </mat-form-field>
    </div>

    <div class="chart-field">
      <app-data-source-selector
        formControlName="dataSource"
        hint="Chooses which datasource the chart will read its values from."
        (onDataSourceChange)="initDataSource($event)"
      ></app-data-source-selector>
    </div>

    <div class="chart-field">
      <mat-form-field appearance="outline">
        <mat-label>Chart Type</mat-label>
        <mat-select formControlName="chartType">
          <mat-option *ngFor="let chartType of chartTypes" [value]="chartType.key">
            {{ chartType.name }}
          </mat-option>
        </mat-select>
        <mat-hint>Changes the visual format used to display the grouped results.</mat-hint>
      </mat-form-field>
    </div>

    <div class="chart-field">
      <mat-form-field appearance="outline">
        <mat-label>Group By</mat-label>
        <mat-select formControlName="groupBy">
          <mat-option *ngFor="let group of availableDataSourceGroups" [value]="group.name">
            {{ group.displayName }}
          </mat-option>
        </mat-select>
        <mat-hint>Controls which datasource field is used to split values into categories.</mat-hint>
      </mat-form-field>
    </div>

    <div class="chart-field">
      <mat-form-field appearance="outline">
        <mat-label>Metric</mat-label>
        <mat-select formControlName="metric">
          <mat-option *ngFor="let metric of availableDataSourceMetrics" [value]="metric.name">
            {{ metric.displayName }}
          </mat-option>
        </mat-select>
        <mat-hint>Determines the value that is calculated for each group.</mat-hint>
      </mat-form-field>
    </div>

    <div class="chart-field">
      <mat-form-field appearance="outline">
        <mat-label>Sorting Order</mat-label>
        <mat-select formControlName="sortOrder">
          <mat-option *ngFor="let sortOrder of sortOrders" [value]="sortOrder.key">
            {{ sortOrder.name }}
          </mat-option>
        </mat-select>
        <mat-hint>Defines how the grouped results are ordered before they are shown.</mat-hint>
      </mat-form-field>
    </div>
  </form>

  <div class="chart-setup-wizard__footer">
    <button mat-flat-button color="primary" (click)="onCreate()">Apply</button>
  </div>
</div>
